import React, { Fragment } from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import ratioUtils from 'Components/utils/ratios/ratios.utils';
import { formatDate } from 'Utils/date/dateUtils';
import { Button } from 'Components/frameworks/button/Button';
import { Image } from 'Components/frameworks/image/Image';
import { Text } from 'Components/frameworks/text/Text';
import { TextHtml } from 'Components/frameworks/text-html/TextHtml';
import { Title } from 'Components/frameworks/title/Title';
type Props = {
  buttonLabel: string;
  className?: string;
  facility: ProductFacility;
  onClick?: () => void;
  openingHoursLabel: string;
};
export const FacilityHours = ({
  buttonLabel,
  className,
  facility,
  onClick,
  openingHoursLabel,
}: Props) => {
  const {
    additionalDescription,
    description,
    id,
    images = [],
    label,
    menu = [],
    openingDays = [],
    reservationLink,
  } = facility;

  const getFormattedDate = (hour) => formatDate('HH:mm')(hour, 'HH:mm:ss');

  return (
    <article className={classnames('space-y-20', className)} id={id}>
      <div className="flex flex-col gap-30 md:flex-row">
        {Boolean(images.length) && (
          <Image
            className="overflow-hidden rounded-12 md:flex-1 md:self-start"
            imageUrl={images[0]}
            ratioKey={ratioUtils.XL}
          />
        )}
        <div className="space-y-10 md:flex-1">
          <Title hLevel={3} theme="title-brand-n2">
            {label}
          </Title>
          <TextHtml theme="text-sans-n3">{additionalDescription}</TextHtml>
          <Text text={description} theme="text-sans-n3" />
          {menu.map(({ href, label: menuLabel }) => (
            <Button key={menuLabel} className="hidden md:inline-flex" onClick={onClick} url={href}>
              {menuLabel}
            </Button>
          ))}
          {reservationLink && (
            <Button className="hidden md:inline-flex" onClick={onClick} url={reservationLink}>
              {buttonLabel}
            </Button>
          )}
        </div>
      </div>
      {Boolean(openingDays.length) && (
        <Fragment>
          <Title className="text-sienna" hLevel={4} theme="title-sans-n4">
            {openingHoursLabel}
          </Title>
          <ul className="gap-30 space-y-20 text-16 md:columns-2">
            {openingDays
              .filter(({ businessHours }) => !!businessHours.length)
              .map(({ businessHours, day }) => (
                <li className="break-inside-avoid" key={day}>
                  <p className="mb-10 font-bold">{day}</p>
                  <ul>
                    {businessHours.map((hour, i) => (
                      <li className="flex justify-between" key={`${day}-${i}`}>
                        {hour.label}
                        <span>
                          {[getFormattedDate(hour.opening), getFormattedDate(hour.closing)].join(
                            ' - ',
                          )}
                        </span>
                      </li>
                    ))}
                  </ul>
                </li>
              ))}
          </ul>
        </Fragment>
      )}
      {reservationLink && (
        <Button className="w-full md:hidden" onClick={onClick} url={reservationLink}>
          {buttonLabel}
        </Button>
      )}
    </article>
  );
};
